module.exports = __webpack_public_path__ + "static/media/2025-AFL-Footy-Lives-Here-Desktop-Banner-@2x.108c9780.jpg";